export const Frequency = {
  WEEKLY: "WEEKLY",
  MONTHLY: "MONTHLY",
  QUARTERLY: "QUARTERLY",
  YEARLY: "YEARLY",
};
export const articles = [
  {
    title:
      "Efficacy of Creatine Supplementation Combined with Resistance Training on Muscle Strength and Muscle Mass in Older Females: A Systematic Review and Meta-Analysis.",
    date: "04/08/2024",
    authors: "A. Earhart, L. Conway",
    journal: "Nutrients",
    insight:
      "Results showed that high- low resistance training improved lean tissue mass, muscle strength, endurance and tasks of functionality and the addition of creatine to high-low resistance training significantly increased body mass and lean tissue mass compared to placebo.",
    results: `- Population: Older females
- Sample Size: Not specified in the abstract; the study is a systematic review and meta-analysis of ten randomized controlled trials (RCTs).
- Methods:
  - Systematic review and meta-analysis of RCTs.
  - Literature search conducted in nine electronic databases.
  - Focus on the efficacy of creatine supplementation (Cr) combined with resistance training (RT) on muscle strength and muscle mass.
- Outcomes: The abstract does not provide specific p-values or effect sizes. The study investigates the impact of creatine supplementation combined with resistance training on upper- and lower-body strength and muscle mass.`,
  },
  {
    title:
      "Impact of Intermittent Fasting on Metabolic Health in Adults: A Comprehensive Review.",
    date: "03/15/2024",
    authors: "J. Doe, S. Smith",
    journal: "Journal of Nutrition",
    insight:
      "Intermittent fasting improved metabolic markers, reduced body fat, and enhanced insulin sensitivity in adults.",
    results: `- Population: Adults
- Sample Size: Various sample sizes from different studies
- Methods:
  - Comprehensive review of multiple studies
  - Examination of different intermittent fasting protocols
- Outcomes: Improved metabolic markers, reduced body fat, and enhanced insulin sensitivity.`,
  },
  {
    title:
      "Effects of Plant-Based Diets on Cardiovascular Health: Evidence from Clinical Trials.",
    date: "01/20/2024",
    authors: "K. Lee, M. Johnson",
    journal: "American Heart Journal",
    insight:
      "Plant-based diets were associated with lower cholesterol levels, improved blood pressure, and reduced risk of cardiovascular diseases.",
    results: `- Population: Adults
- Sample Size: Various sample sizes from different clinical trials
- Methods:
  - Review of clinical trials
  - Focus on cardiovascular health outcomes
- Outcomes: Lower cholesterol levels, improved blood pressure, and reduced risk of cardiovascular diseases.`,
  },
  {
    title:
      "Role of Omega-3 Fatty Acids in Cognitive Function and Neuroprotection.",
    date: "02/12/2024",
    authors: "L. White, P. Green",
    journal: "Brain Research",
    insight:
      "Omega-3 fatty acids demonstrated neuroprotective effects and enhanced cognitive function in aging populations.",
    results: `- Population: Aging populations
- Sample Size: Various sample sizes from different studies
- Methods:
  - Review of studies on omega-3 fatty acids
  - Focus on cognitive function and neuroprotection
- Outcomes: Neuroprotective effects and enhanced cognitive function.`,
  },
  {
    title: "The Influence of Probiotics on Gut Microbiota and Immune Function.",
    date: "05/05/2024",
    authors: "E. Brown, T. Davis",
    journal: "Gut Health Journal",
    insight:
      "Probiotics improved gut microbiota composition and enhanced immune response in clinical trials.",
    results: `- Population: Various populations
- Sample Size: Various sample sizes from different clinical trials
- Methods:
  - Review of clinical trials on probiotics
  - Examination of gut microbiota composition and immune function
- Outcomes: Improved gut microbiota composition and enhanced immune response.`,
  },
  {
    title:
      "Comparative Analysis of Low-Carb and Low-Fat Diets for Weight Loss and Metabolic Health.",
    date: "06/18/2024",
    authors: "R. Martin, B. Lopez",
    journal: "Obesity Reviews",
    insight:
      "Both low-carb and low-fat diets were effective for weight loss, but low-carb diets showed greater improvements in metabolic health markers.",
    results: `- Population: Adults with obesity
- Sample Size: Various sample sizes from different studies
- Methods:
  - Comparative analysis of low-carb and low-fat diets
  - Focus on weight loss and metabolic health markers
- Outcomes: Effective weight loss with both diets; greater improvements in metabolic health markers with low-carb diets.`,
  },
  {
    title:
      "Vitamin D Supplementation and Its Effects on Bone Density in Postmenopausal Women.",
    date: "07/22/2024",
    authors: "S. Thompson, A. Harris",
    journal: "Bone Health Journal",
    insight:
      "Vitamin D supplementation increased bone density and reduced the risk of fractures in postmenopausal women.",
    results: `- Population: Postmenopausal women
- Sample Size: Various sample sizes from different studies
- Methods:
  - Review of studies on vitamin D supplementation
  - Examination of bone density and fracture risk
- Outcomes: Increased bone density and reduced risk of fractures.`,
  },
  {
    title:
      "Physical Activity and Its Association with Mental Health Outcomes in Adolescents.",
    date: "08/30/2024",
    authors: "D. Wilson, H. Clark",
    journal: "Pediatric Health",
    insight:
      "Regular physical activity was linked to improved mental health outcomes, including reduced anxiety and depression in adolescents.",
    results: `- Population: Adolescents
- Sample Size: Various sample sizes from different studies
- Methods:
  - Review of studies on physical activity
  - Examination of mental health outcomes
- Outcomes: Improved mental health outcomes, including reduced anxiety and depression.`,
  },
  {
    title:
      "Impact of Sleep Quality on Academic Performance and Cognitive Function in College Students.",
    date: "09/10/2024",
    authors: "G. Hall, N. Baker",
    journal: "Journal of Sleep Research",
    insight:
      "Poor sleep quality was associated with lower academic performance and impaired cognitive function in college students.",
    results: `- Population: College students
- Sample Size: Various sample sizes from different studies
- Methods:
  - Review of studies on sleep quality
  - Examination of academic performance and cognitive function
- Outcomes: Lower academic performance and impaired cognitive function associated with poor sleep quality.`,
  },
  {
    title:
      "Effects of Green Tea Extract on Weight Loss and Metabolic Health in Obese Adults.",
    date: "10/02/2024",
    authors: "V. Adams, W. Campbell",
    journal: "Metabolism Journal",
    insight:
      "Green tea extract supplementation resulted in significant weight loss and improvements in metabolic health markers in obese adults.",
    results: `- Population: Obese adults
- Sample Size: Various sample sizes from different studies
- Methods:
  - Review of studies on green tea extract supplementation
  - Examination of weight loss and metabolic health markers
- Outcomes: Significant weight loss and improvements in metabolic health markers.`,
  },
  {
    title:
      "The Role of Antioxidants in Reducing Oxidative Stress and Inflammation in Chronic Diseases.",
    date: "11/15/2024",
    authors: "I. Carter, J. Nelson",
    journal: "Chronic Disease Journal",
    insight:
      "Antioxidant supplementation reduced oxidative stress and inflammation, contributing to better management of chronic diseases.",
    results: `- Population: Individuals with chronic diseases
- Sample Size: Various sample sizes from different studies
- Methods:
  - Review of studies on antioxidant supplementation
  - Examination of oxidative stress and inflammation
- Outcomes: Reduced oxidative stress and inflammation, better management of chronic diseases.`,
  },
  {
    title:
      "Evaluating the Benefits of High-Intensity Interval Training on Cardiovascular Fitness.",
    date: "12/01/2024",
    authors: "R. Lewis, K. Walker",
    journal: "Fitness Journal",
    insight:
      "High-intensity interval training significantly improved cardiovascular fitness and overall health compared to moderate-intensity exercise.",
    results: `- Population: Adults
- Sample Size: Various sample sizes from different studies
- Methods:
  - Review of studies on high-intensity interval training
  - Examination of cardiovascular fitness and overall health
- Outcomes: Significant improvements in cardiovascular fitness and overall health.`,
  },
  {
    title:
      "Nutritional Strategies for Enhancing Athletic Performance: A Review.",
    date: "01/05/2024",
    authors: "M. Young, F. Evans",
    journal: "Sports Nutrition",
    insight:
      "Specific nutritional strategies, including protein and carbohydrate intake, were shown to enhance athletic performance and recovery.",
    results: `- Population: Athletes
- Sample Size: Various sample sizes from different studies
- Methods:
  - Review of studies on nutritional strategies
  - Examination of athletic performance and recovery
- Outcomes: Enhanced athletic performance and recovery with specific nutritional strategies.`,
  },
];
